// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"7ce85783","42":"b4afb24c","230":"4f867f39","287":"b7a590d6","415":"83f397f2","729":"2b596981","796":"333a92ef","925":"e409862c"}[chunkId] + ".js";
};